import type { LngLat, Point } from './SurfaceBase';

export type CanvasEvents = {
  tap: (e: CanvasEvent) => void;
  dblTap: (e: CanvasEvent) => void;

  hoverStart: (e: HoverEvent) => void;
  hovering: (e: HoverEvent) => void;
  hoverEnd: (e: HoverEvent) => void;

  dragStart: (e: DragEvent) => void;
  dragging: (e: DragEvent) => void;
  dragEnd: (e: DragEvent) => void;

  scaleStart: (e: DragEvent, resizeHandleIndex: number) => void;
  scaling: (e: DragEvent, resizeHandleIndex: number) => void;
  scaleEnd: () => void;

  rotateStart: () => void;
  rotating: (e: CanvasRotateEvent) => void;
  rotateEnd: () => void;

  keyPress: (e: KeyboardEvent) => void;
};

interface CanvasPointerEvent {
  point: Point;
  lngLat: LngLat;
}

interface CanvasDragEvent {
  startPoint: Point;
  startLngLat: LngLat;
  currentPoint: Point;
  currentLngLat: LngLat;
}

interface CanvasRotateEvent {
  angle: number; // in radians
}

export class CanvasEvent {
  type: keyof CanvasEvents;
  point: Point;
  lngLat: LngLat;
  _shouldBubble: boolean = true;

  constructor(type: keyof CanvasEvents, props: CanvasPointerEvent) {
    this.type = type;
    this.point = props.point;
    this.lngLat = props.lngLat;
  }

  stopBubble() {
    this._shouldBubble = false;
  }

  shouldBubble() {
    return this._shouldBubble;
  }
}

export class HoverEvent extends CanvasEvent {}

export class TapEvent extends CanvasEvent {}

export class DoubleTapEvent extends CanvasEvent {}

export class DragEvent extends CanvasEvent {
  startPoint: Point;
  startLngLat: LngLat;

  currentPoint: Point;
  currentLngLat: LngLat;

  constructor(type: keyof CanvasEvents, props: CanvasDragEvent) {
    super(type, { point: props.currentPoint, lngLat: props.currentLngLat });

    this.startPoint = props.startPoint;
    this.startLngLat = props.startLngLat;

    this.currentPoint = props.currentPoint;
    this.currentLngLat = props.currentLngLat;
  }

  diff(): Point {
    return {
      x: this.currentPoint.x - this.startPoint.x,
      y: this.currentPoint.y - this.startPoint.y,
    };
  }
}
